<template>
  <footer class="footer">
    <div class="footer-wave"></div>
    <div class="container">
      <div class="footer-content">
        <div class="footer-logo">
          <p>Radio App - FM Radio Stations</p>
          <div class="app-description">
            Your Global Radio Companion, Listen to the World Anytime, Anywhere
          </div>
        </div>
        <div class="footer-links">
          <div class="links-grid">
            <div class="links-column">
              <h4>Navigation</h4>
              <ul>
                <li><router-link to="/">Home</router-link></li>
                <li><a href="/#features">Features</a></li>
                <li><a href="/#image-carousel">Showcase</a></li>
                <li><a href="/#download">Download</a></li>
              </ul>
            </div>
            <div class="links-column">
              <h4>Legal</h4>
              <ul>
                <li><a href="/privacy">Privacy Policy</a></li>
                <li><a href="/term">Terms</a></li>
                <li><router-link to="/faq">FAQ</router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>Copyright © 2024 go.rgb-radio.com All rights reserved</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style scoped>
.footer {
  background: linear-gradient(135deg, #1D254C, #2A3365);
  color: #fff;
  padding: 80px 0 20px;
  position: relative;
  overflow: hidden;
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 20% 30%, rgba(74, 134, 232, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 80% 70%, rgba(125, 171, 245, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.footer-wave {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100"><path fill="%23ffffff" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path></svg>');
  background-size: cover;
  background-position: center bottom;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  position: relative;
  z-index: 2;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 40px;
  gap: 40px;
}

.footer-logo {
  flex: 0 0 40%;
  padding-right: 20px;
}

.footer-logo p {
  font-size: 16px;
  margin-bottom: 10px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
  letter-spacing: 0.5px;
}

.app-description {
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
  color: rgba(255, 255, 255, 0.7);
  max-width: 300px;
  position: relative;
  padding-left: 15px;
  border-left: 2px solid rgba(74, 134, 232, 0.5);
}

.footer-links {
  flex: 0 0 50%;
  display: flex;
  align-items: flex-start;
}

.links-grid {
  display: flex;
  gap: 60px;
  width: 100%;
}

.links-column {
  flex: 1;
}

.links-column h4 {
  color: white;
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: 600;
  position: relative;
  display: inline-block;
  letter-spacing: 0.5px;
}

.links-column h4::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 30px;
  height: 2px;
  background: linear-gradient(90deg, #4a86e8, #7dabf5);
  border-radius: 2px;
}

.footer ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer ul li {
  margin-bottom: 12px;
}

.footer a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 15px;
  display: inline-block;
  position: relative;
  padding-left: 0;
}

.footer a:hover {
  color: white;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
  text-align: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.footer-bottom::before {
  content: '';
  position: absolute;
  top: -1px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(74, 134, 232, 0.5), transparent);
}

@media (max-width: 768px) {
  .footer {
    padding: 60px 0 20px;
  }

  .footer-content {
    flex-direction: column;
    text-align: center;
  }
  
  .footer-logo, .footer-links {
    flex: 0 0 100%;
    margin-bottom: 30px;
  }
  
  .footer-logo {
    padding-right: 0;
  }
  
  .app-description {
    max-width: none;
    margin: 0 auto 20px;
    padding-left: 0;
    padding-top: 15px;
    border-left: none;
    border-top: 2px solid rgba(74, 134, 232, 0.5);
  }
  
  .links-grid {
    flex-direction: row;
    gap: 20px;
    justify-content: center;
  }
  
  .links-column {
    flex: 0 0 45%;
    text-align: center;
  }
  
  .links-column h4 {
    display: block;
    text-align: center;
    margin: 0 auto 25px;
    font-size: 17px;
  }
  
  .links-column h4::after {
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
  }
  
  .footer ul {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .footer-bottom {
    margin-top: 10px;
  }
  
  .footer-bottom p {
    font-size: 12px;
    line-height: 1.5;
    padding: 0 10px;
  }
}
</style> 